/*
 * @Descripttion: 
 * @version: 
 * @Author: Royalzxl
 * @Date: 2020-04-07 11:50:42
 * @LastEditors: Royalzxl
 * @LastEditTime: 2020-04-07 12:00:18
 */
import Tipstemplate from './tips.vue'

let Tips = {}

Tips.install = function(Vue,options={}){
    
    const VueTips = Vue.extend(Tipstemplate)  //创建模板
    
    let tips = null

    Vue.prototype.$tips = (params) =>{
        let options = {};
        options.time = 2000;
        options.text = "hello";
        if(!tips){
            tips = new VueTips().$mount()  //创建实例
            document.body.appendChild(tips.$el)  //挂载实例
        }

        if(typeof params == 'string') {
            options.text = params;
        }
        if(typeof params == 'object') {
            Object.assign({}, options, params)
        }
        tips.show(options)
        
    }
}


export default Tips